import { HasPermissionService } from 'app/shared/haspermission/hasPermission.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { LayoutService } from "../layout.service";
import { AuthService } from "../../../+login/auth.service";
import { NotificationService } from "../../utils/notification.service";
import { I18nPipe } from "../../i18n/i18n.pipe";
import { UsersActionsComponent } from '../../../+admin/+users/+actions/users-actions.component';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap';
import { environment } from "../../../../environments/environment";
import { 
    HeaderService,
    NotificationCategory,
    NotificationPriority,
    NotificationStatus,
    NotificationStatusUpdate,
    NotificationType,
    NotificationUpdate,
    NotificationView
} from './header.service';
import { NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import 'moment/min/locales';
import { WebSocketService } from '../../../common/http/web.socket.service';
import { OfflineSalesActionsComponent } from 'app/+admin/+offline-sales/+offline-sales-actions/offline-sales-actions.component';
import { OfflineOperationsActionsComponent } from 'app/+admin/+offline-operations-actions/offline-operations-actions.component';
let moment = require('moment');

declare var $: any;

@Component({
    selector: 'sa-header',
    templateUrl: './header.component.html',
    styleUrls: ['header.css'],
    providers: [ BsModalService ]
})
export class HeaderComponent implements OnInit , OnDestroy{
    public dialogContent1: string = this.i18n.transform('Log Out?');
    public idLogueado: number;
    private bsModalNewUser: BsModalRef;
    public logoMegacable: boolean = false;
    @ViewChild('gruposModal') public gruposModal: ModalDirective;
    public notifyModal: BsModalRef;
    
    // Info user logged from localStorage
    public infoUserLogged: any = null;
    public canShowApkOffline: boolean = false;

    loaderNotifi: boolean = false;
    loaderNotifiAlerts: boolean = false;
    contadorNotificacion:any;
    notifications: Array<NotificationView> = [];
    notificationsAlerts: Array<NotificationView> = [];
    notificationCategorizerToggle: number;
    notificationCategories: { [notificationType: number]: NotificationCategory[] } = {}; // Read constructor for initialize process
    selectedNotificationCategory: NotificationCategory[] = [];

    notificacionesPanic: Array<NotificationView> = [];
    private arrayNumberNoti: Array <any> = [
        {
            'idType': 1,
            'count': 3
        },
        {
            'idType': 2,
            'count': 2
        }
    ];
    public showCollapsedMenu: boolean = false;
    notificationCounter = 0;
    notificationCounterAlerts = 0;
    panicNotificationCounter = 0;
    contadorTipoChatTask = 0;
    contadorTipoChatTicket = 0;
    private searchMobileActive = false;
    private intervalNotifications: number;

    constructor(private router: Router,
                private authService: AuthService,
                private layoutService: LayoutService,
                private notificationService: NotificationService,
                private bsModalService: BsModalService,
                private activatedRoute: ActivatedRoute,
                private i18n: I18nPipe,
                private message: NzMessageService,
                private webSocketService: WebSocketService,
                private headerService: HeaderService,
                private hasPermissionService: HasPermissionService) {
        i18n.i18nService.subscribe(() => {
            this.dialogContent1 = this.i18n.transform("Log Out?");
        }, null);

        let url = document.location.href.toString();
        let produccionURL = /https\:\/\/apps\.inbyte\.mx/;
        // url = 'https://apps.inbyte.mx/#/login'
        let fltr1 = url.match(produccionURL);

        if (environment.api_url == 'https://apps.inbyte.mx:9011' || fltr1 != null) {
            this.logoMegacable = true;
        } else {
            this.logoMegacable = false;
        }

        // Initialize notificationCategories catalog
        for (const value in NotificationType) {
            const notificationType: number = Number(value);
            if (!isNaN(notificationType)) {
                this.headerService.getNotificationCategories(notificationType)
                .subscribe((notificationCategories) => this.notificationCategories[notificationType] = notificationCategories);
            }
        }
    }

reproducirAudio(){
    if(this.hasPermissionService.canAccess('ACTIVE_SOUND')){

    
   // const audio = new Audio("https://manzdev.github.io/codevember2017/assets/eye-tiger.mp3");
   const audio = new Audio("../../../assets/audio/audio.mp3");
    audio.play();          // Comienza a reproducir el audio
    // audio.pause();         // Pausa el audio
    // audio.play();          // Continua el audio por donde fue pausado
    
    // audio.pause();         // Vuelve a pausar
    // audio.currentTime = 0; // Coloca la reproducción en el segundo 0 (inicio)
    // audio.play(); 
}

}
    ngOnInit(): void {
        this.layoutService.subscribe((success) => {
            if (success.mobileViewActivated) {
                this.showCollapsedMenu = true;
            } else {
                this.showCollapsedMenu = false;
            }
        });
        jQuery('.trigger').click(function () {
            jQuery("#" + $(this).attr('href')).toggle('slow');
            return false;
        });
        this.idLogueado = this.authService.token.userId;
        this.loadInfoUserLogged();
        // this.obtenerNotificacionesPanic();
        // this.obtenerNotificaciones(null, 1);
        this.obtenerNotificaciones(null, 2);
        this.getNotificationsCounter();
    }

    private loadInfoUserLogged(): void {
        this.infoUserLogged = JSON.parse(localStorage.getItem('info_user_logged') || 'null');
        if (this.infoUserLogged && this.infoUserLogged.userAppView && ([1,69].includes(this.infoUserLogged.userAppView.profileId) || ['Atencion Domiciliaria Administrador', 'Administrador de sistema'].includes(this.infoUserLogged.userAppView.profileName))) {
            this.canShowApkOffline = true;
        }
    }

    private getNotificationsCounter(fromInterval: boolean = false): void {
        this.contadorNotificacion = this.notificationCounter;
        if (!this.intervalNotifications || fromInterval) {
            const notificationsTypes: NotificationType[] = [
                NotificationType.NORMAL,
                NotificationType.TICKET,
                NotificationType.GPS,
                NotificationType.SECURITY,
                NotificationType.ALERT,
                NotificationType.NO_SALE,
                NotificationType.SPEED_ALERT,
                NotificationType.MAXTIME_ON_TICKET,
                NotificationType.GEOFENCES,
                NotificationType.ASIGNE_TASK,
                NotificationType.SOLVE_TASK,
                NotificationType.TICKET_CHAT,
                NotificationType.TASK_CHAT,
                NotificationType.TIME_KILLED,
                NotificationType.FOOD,
                NotificationType.BATHROOM,
                NotificationType.TRAFFIC,
                NotificationType.FUEL_REFILL,
            ];
            const priority: NotificationPriority[] = [
                NotificationPriority.LOW,
                NotificationPriority.MEDIUM,
                NotificationPriority.HIGH
            ];
            const status: NotificationStatus[] = [NotificationStatus.NEW];

            this.headerService.getNumberNotifications(this.authService.token.userId, notificationsTypes, priority, status)
                .subscribe((response) => {
                    this.notificationCounter = 0;
                    this.panicNotificationCounter = 0;
                    this.arrayNumberNoti = response;
                    this.arrayNumberNoti.forEach((element) => {
                        if (element.idType != NotificationType.ALERT) {
                            this.notificationCounter += element.count;
                        } else {
                            this.panicNotificationCounter += element.count;
                        }
                    });

                    let datoLocal = parseInt(localStorage.getItem('Notificaciones'));
                    let datoenviar = this.notificationCounter.toString();

                    if (datoLocal) {
                        //tengo notificaciones en el localStorage
                        if (datoLocal != this.notificationCounter) {
                            //evaluar notificaciones
                            for (let i = 0; i < this.arrayNumberNoti.length; i++) {
                                if (this.arrayNumberNoti[i].idType == NotificationType.TICKET_CHAT) {
                                    if (this.contadorTipoChatTicket < this.arrayNumberNoti[i].count) {
                                        this.reproducirAudio();
                                        this.contadorTipoChatTicket = this.arrayNumberNoti[i].count;
                                        break;
                                    }
                                }
                                if (this.arrayNumberNoti[i].idType == NotificationType.TASK_CHAT) {
                                    if (this.contadorTipoChatTask < this.arrayNumberNoti[i].count) {
                                        this.reproducirAudio();
                                        this.contadorTipoChatTask = this.arrayNumberNoti[i].count;
                                        break;
                                    }
                                }
                            }
                            this.contadorNotificacion = this.notificationCounter;
                            localStorage.setItem("Notificaciones", datoenviar);

                        }
                    } else {
                        //No tengo notificaciones en el localStorage y las Cargo

                        for (let i = 0; i < this.arrayNumberNoti.length; i++) {
                            if (this.arrayNumberNoti[i].idType == NotificationType.TICKET_CHAT) {
                                if (this.contadorTipoChatTicket < this.arrayNumberNoti[i].count) {
                                    this.reproducirAudio();
                                    this.contadorTipoChatTicket = this.arrayNumberNoti[i].count;
                                    break;
                                }
                            }
                            if (this.arrayNumberNoti[i].idType == NotificationType.TASK_CHAT) {
                                if (this.contadorTipoChatTask < this.arrayNumberNoti[i].count) {
                                    this.reproducirAudio();
                                    this.contadorTipoChatTask = this.arrayNumberNoti[i].count;
                                    break;
                                }
                            }
                        }
                        localStorage.setItem("Notificaciones", datoenviar);
                    }
                }, () => {
                    console.error('No fue posible obtener el número de notificaciones pendientes.');
                }, () => {
                    // if (!this.intervalNotifications) {
                    //     this.intervalNotifications = window.setInterval(() => this.getNotificationsCounter(true), 40000);
                    // }
                });
        }
    }

    ngOnDestroy(): void {
        window.clearInterval(this.intervalNotifications);
        if (this.bsModalNewUser) {
            this.bsModalNewUser.hide();
        }
    }

    createMessage(type: string, mensaje: string): void {
        this.message.create(type, mensaje);
    }

    newUser(): void {
        this.bsModalNewUser = this.bsModalService.show(UsersActionsComponent, {
            class: 'new-user-modal ',
            backdrop: 'static',
            initialState: {
                action: 'edit',
                id: this.idLogueado,
                viewProfile: false,
                noValidateEmployeeNumber: true,
                fromHeader: true
            }
        });

        try {
            const bsModal: Element = document.getElementsByClassName('new-user-modal')[0];
            bsModal.parentElement.classList.add('new-user-dialog');
            bsModal.parentElement.style.display = 'flex';
            const bsModalBackdrop: Element = bsModal.parentElement.previousElementSibling;
            if (bsModalBackdrop.nodeName.toLowerCase() == 'bs-modal-backdrop') {
                bsModalBackdrop.classList.add('bs-modal-backdrop-white');
            }
        } catch (e) {
        }
    }

    settingsVentasFueraLinea():void{
        this.bsModalNewUser = this.bsModalService.show(OfflineSalesActionsComponent, {});
    }

    settingsOperacionesFueraLinea(): void {
        this.bsModalNewUser = this.bsModalService.show(OfflineOperationsActionsComponent, {});
    }
    
    toggleSearchMobile(): void {
        this.searchMobileActive = !this.searchMobileActive;
        $('body').toggleClass('search-mobile', this.searchMobileActive);
    }

    onSubmit(): void {
        this.router.navigate(['/miscellaneous/search']);
    }

    logOut(): void {
        this.notificationService.smartMessageBox({
                title: `${this.dialogContent1}`,
                content: `${this.notificationService.getAreYouSure()}`,
                buttons: '[No][Si]'
            }, (ButtonPressed) => {
                if (ButtonPressed === "Si") {
                    // delete items from local Storage
                    // desconectar del socket
                   this.webSocketService.disconnectSocket();
                    localStorage.removeItem('asignoTicketSearch');
                    localStorage.removeItem('Notificaciones');
                    localStorage.removeItem('auth_token');
                    localStorage.removeItem('foliosOTS');
                    localStorage.removeItem('usersBySupervisor');
                    this.authService.logout();
                }
            }
        )
    }

    private contarSinLeer(opc: number): void {
        switch (opc) {
            case 1:
                this.notificationCounter = this.notifications.filter(item => item.status == 1).length;
                break;
            case 2:
                this.notificationCounterAlerts = this.notificationsAlerts.filter(item => item.status == 1).length;
                let values = this.openeOtherNotifyValidation();
                if (this.notificationCounterAlerts > 0 && values.value != null && values.open == true) {
                    this.cerrarNotificaciones();
                    if (this.headerService.isOpenedNotifyModal == false) {
                        this.notifyModal = this.bsModalService.show(NotifyModalComponent, {
                            class: 'modal-custom',
                            backdrop: 'static',
                            initialState: {
                                notifications: [values.value],
                                // notificationCategories: this.notificationCategories
                            }
                        });
                    }
                }
                break;
        }
    }
    openeOtherNotifyValidation(): any {
        let list:any = [];
        for (const element of this.notificationsAlerts) {
            if (
                element.status === 1 &&
                element.extraInfo.length > 0 &&
                element.extraInfo[0].posponer &&
                element.extraInfo[0].posponer.trim() !== ''
            ) {
                const compareDate = new Date(element.extraInfo[0].posponer);
                if (compareDate <= new Date()) {
                    list.push({ open: true, value: element });
                }
            }
            else if(
                element.status === 1 &&
                (element.extraInfo.length == 0 || (element.extraInfo.length > 0 && !element.extraInfo[0].posponer))
            ){
                list.push({ open: true, value: element });
            }
        }
        if(list.length > 0){
            return { open: true, value: list[0].value };
        }
        return { open: true, value: null };
    }
    
    public openNotification(notification:any): void {
        if(notification.status != 1)
        {
            return;
        }
        let newArray = [];
        newArray.push(notification); 
        this.cerrarNotificaciones();
        if(this.headerService.isOpenedNotifyModal == false){
            this.notifyModal = this.bsModalService.show(NotifyModalComponent, {
                class: 'modal-custom',
                backdrop: 'static',
                initialState: {
                    notifications: newArray,
                }
            });
        }
    }
    private contarSinLeerPanic(): void {
        this.panicNotificationCounter = this.notificacionesPanic.filter(item => item.status == 1).length;
    }



    obtenerNotificaciones(e?: any, opc?: number): void {
        switch (opc) {
            case 1:
                if (e) {
                    e.stopPropagation();
                    $('#contPrincipalNotiPanic.open').removeClass('open');
                    $('#toggleNotificationsPanic').attr('aria-expanded', 'false');
                    $('#contPrincipalNotiAlerts.open').removeClass('open');
                    $('#toggleNotificationsAlerts').attr('aria-expanded', 'false');
                    $('#contentNotifications').addClass('moverCuadro');
                    window.setTimeout(() => {
                        $('#contentNotifications').removeClass('moverCuadro');
                    }, 5);
                }
                this.loaderNotifi = true;
                // if (this.notificationPanicOpen) {
                //     $('#toggleNotificationsPanic').click();
                //     console.log('Esta visible las de panico');
                // }

                this.notifications = [];
                delete this.notificationCategorizerToggle;
                // notifications type
                const notificationsTypes: NotificationType[] = [
                    NotificationType.NORMAL,
                    NotificationType.TICKET,
                    NotificationType.GPS,
                    NotificationType.SECURITY,
                    NotificationType.NO_SALE,
                    NotificationType.SPEED_ALERT,
                    NotificationType.MAXTIME_ON_TICKET,
                    NotificationType.GEOFENCES,
                    NotificationType.SOLVE_TASK,
                    NotificationType.ASIGNE_TASK,
                    NotificationType.TICKET_CHAT,
                    NotificationType.TASK_CHAT,
                    NotificationType.TIME_KILLED,
                    NotificationType.FOOD,
                    NotificationType.BATHROOM,
                    NotificationType.TRAFFIC,
                    NotificationType.FUEL_REFILL,
                ];
                const priority: NotificationPriority[] = [
                    NotificationPriority.LOW,
                    NotificationPriority.MEDIUM,
                    NotificationPriority.HIGH
                ];
                const status: NotificationStatus[] = [
                    NotificationStatus.NEW,
                    NotificationStatus.READED
                ];
                /** esto va dentro del response, si se cuenta con notificaciones se va a hacer el tratado de la informacion, para pintarla correctamente **/

                this.headerService.getNotifications(this.authService.token.userId, notificationsTypes, priority, status)
                    .subscribe((response) => {
                        this.notifications = response;
                        for (let i = 0; i < response.length; i++) {
                            if (response[i].idType == NotificationType.TICKET_CHAT ||
                                response[i].idType == NotificationType.TASK_CHAT) {
                                this.reproducirAudio();
                                break;
                            }
                        }
                        this.selectedNotificationCategory = this.notifications.map((notification) => {
                            if (this.canCategorize(notification.idType)) {
                                return notification.extraInfo.find((notifExtraInfo) => notifExtraInfo.hasOwnProperty('idCategory'));
                            } else {
                                return null;
                            }
                        });
                        // dejar solo una notificacion
                        this.contarSinLeer(1);
                        this.loaderNotifi = false;
                    }, (error) => {
                        this.loaderNotifi = false;
                        console.error('No fue posible obtener las notificaciones.');
                    }, () => {
                        window.setTimeout(() => {
                            if (this.notifications.length >= 3) {
                                let tamanoDiv = 0;
                                tamanoDiv = $('#cotNotifi0').height() + $('#cotNotifi1').height() + $('#cotNotifi2').height();
                                $('#divNotifiScroll').css('max-height', tamanoDiv + 'px');
                            }
                        }, 200);

                        this.loaderNotifi = false;
                    });
                break;

            case 2:
                if (e) {
                    e.stopPropagation();
                    $('#contPrincipalNotiPanic.open').removeClass('open');
                    $('#toggleNotificationsPanic').attr('aria-expanded', 'false');
                    $('#contPrincipalNoti.open').removeClass('open');
                    $('#toggleNotifications').attr('aria-expanded', 'false');
                    $('#contentNotificationsAlerts').addClass('moverCuadro');
                    window.setTimeout(() => {
                        $('#contentNotificationsAlerts').removeClass('moverCuadro');
                    }, 5);
                }

                this.loaderNotifiAlerts = true;
                // if (this.notificationPanicOpen) {
                //     $('#toggleNotificationsPanic').click();
                //     console.log('Esta visible las de panico');
                // }

                this.notificationsAlerts = [];
                delete this.notificationCategorizerToggle;
                // notifications type
                const notificationsTypesAlerts: NotificationType[] = [
                    NotificationType.TRAFFIC_ACCIDENT,
                    NotificationType.VEHICLE_BREAKDOWN,
                    NotificationType.BAD_WEATHER,
                    NotificationType.CRIME,
                    NotificationType.ILLNESS,
                    NotificationType.WORK_AREA_INCIDENT,
                ];
                const priorityAlerts: NotificationPriority[] = [
                    NotificationPriority.LOW,
                    NotificationPriority.MEDIUM,
                    NotificationPriority.HIGH
                ];
                const statusAlerts: NotificationStatus[] = [
                    NotificationStatus.NEW,
                    NotificationStatus.READED
                ];

                this.headerService.getNotifications(this.authService.token.userId, notificationsTypesAlerts, priorityAlerts, statusAlerts, true)
                    .subscribe((response) => {
                        this.notificationsAlerts = response;
                        this.selectedNotificationCategory = this.notificationsAlerts.map((notification) => {
                            if (this.canCategorize(notification.idType)) {
                                return notification.extraInfo.find((notifExtraInfo) => notifExtraInfo.hasOwnProperty('idCategory'));
                            } else {
                                return null;
                            }
                        });
                        // dejar solo una notificacion
                        this.contarSinLeer(2);
                        this.loaderNotifiAlerts = false;
                    }, (error) => {
                        this.loaderNotifiAlerts = false;
                        console.error('No fue posible obtener las notificaciones.');
                    }, () => {
                        window.setTimeout(() => {
                            if (this.notificationsAlerts.length >= 3) {
                                let tamanoDiv = 0;
                                tamanoDiv = $('#cotNotifi0').height() + $('#cotNotifi1').height() + $('#cotNotifi2').height();
                                $('#divNotifiScroll').css('max-height', tamanoDiv + 'px');
                            }
                        }, 200);

                        this.loaderNotifiAlerts = false;
                    });
                break;
            default:
                break;
        }

    }
    obtenerNotificacionesPanic(e?): void {
        if(e)
        {
            e.stopPropagation();
            $('#contPrincipalNoti.open').removeClass('open');
            $('#contPrincipalNotiAlerts.open').removeClass('open');
            $('#toggleNotifications').attr('aria-expanded', 'false');
            $('#toggleNotificationsAlerts').attr('aria-expanded', 'false');
            $('#contentNotificationsPanic').addClass('moverCuadro');
            window.setTimeout(() => { $('#contentNotificationsPanic').removeClass('moverCuadro'); }, 5);
           
        }
        this.loaderNotifi = true;
        this.notificacionesPanic = [];

        const notificationsTypes: NotificationType[] = [
            NotificationType.ALERT
        ];
        const priority: NotificationPriority[] = [
            NotificationPriority.LOW,
            NotificationPriority.MEDIUM,
            NotificationPriority.HIGH
        ];
        const status: NotificationStatus[] = [
            NotificationStatus.NEW,
            NotificationStatus.READED
        ];
        /** esto va dentro del response, si se cuenta con notificaciones se va a hacer el tratado de la informacion, para pintarla correctamente **/
        this.headerService.getNotifications(this.authService.token.userId, notificationsTypes, priority, status)
        .subscribe((response) => {
            this.notificacionesPanic = response;
            for (let i = 0; i < response.length; i++) {
                if (response[i].idType == NotificationType.TICKET_CHAT ||
                    response[i].idType == NotificationType.TASK_CHAT) {
                    this.reproducirAudio();
                    break;
                }
            }
            this.selectedNotificationCategory = this.notificacionesPanic.map((notification) => {
                if (this.canCategorize(notification.idType)) {
                    return notification.extraInfo.find((notifExtraInfo) => notifExtraInfo.hasOwnProperty('idCategory'));
                } else {
                    return null;
                }
            });
            this.notificacionesPanic.forEach((element, index) => {
                if (!element.extraInfo.length) {
                    this.notificacionesPanic[index].extraInfo = null;
                }
            });
            this.contarSinLeerPanic();
            this.loaderNotifi =  false;
        }, (error) => {
            this.loaderNotifi =  false;
            console.error('No fue posible obtener las notificaciones.');
        }, () => {
            window.setTimeout(() => {
                if (this.notificacionesPanic.length >= 3) {
                    let tamanoDiv = 0;
                    tamanoDiv = $('#cotNotifiPanic0').height() + $('#cotNotifiPanic1').height() + $('#cotNotifiPanic2').height();
                    $('#divNotifiScrollPanic').css('max-height', tamanoDiv + 'px');
                }
            } , 200);

            this.loaderNotifi =  false;
        });
    }

    menuUser(): void {
        $('#dropdown-header-menu').addClass('moverCuadro');
        // $('#toggleNotifications').attr('aria-expanded', 'true');
        window.setTimeout(() => { $('#dropdown-header-menu').removeClass('moverCuadro'); } , 5);
    }

    acciondeNotificacion(notification: NotificationView): boolean {
        if (notification.extraInfo != null) {
            switch (notification.idType) {
                case NotificationType.ALERT:
                    this.headerService.emitItem(notification);
                    this.router.navigate(['/gps/routes/', notification.extraInfo[0].idUserApp], {relativeTo: this.activatedRoute});
                    break;
                case NotificationType.MAXTIME_ON_TICKET:
                    this.headerService.emitItem(notification);
                    this.router.navigate(['/gps/routes/', notification.extraInfo[0].idUser], {relativeTo: this.activatedRoute});
                    break;
                case NotificationType.NO_SALE:
                    this.headerService.emitItem(notification);
                    break;
                case NotificationType.TICKET_CHAT:

                   this.headerService.emitItem(notification);
                   this.router.navigate(['tickets/details/', notification.extraInfo[0].idTicket]);

                   break;
                case NotificationType.TASK_CHAT:
                   this.headerService.emitItem(notification);
                   this.router.navigate(['tickets/details/', notification.extraInfo[0].idTicket,'task',notification.extraInfo[0].idTicket,notification.extraInfo[0].idTask]);
                   break;  
                case NotificationType.TICKET:
                    console.log(notification.extraInfo[0].idTicket);
                    this.router.navigate(['tickets/details/', notification.extraInfo[0].idTicket]);
                     this.headerService.emitItem(notification);
                   break;    
                default:
                    break;
            }
            return true;
        } else {
            this.headerService.emitItem('false');
            return false;
        }
    }

    marcarLeida(notificacion, panic, opc: number): void {
        const notificationStatusUpdate: NotificationStatusUpdate = new NotificationStatusUpdate(notificacion);
        notificationStatusUpdate.idStatus = 2;

        this.headerService.updateNotificationStatus(notificationStatusUpdate)
        .subscribe(() => {
            this.createMessage('success', 'La notificación se marcó como leída');
        }, (error) => {
            console.error('no se actualizo la notificacion');
            this.createMessage('error', 'No fue posible marcar la notificación como leída');
        },  () => {
            if (!panic && opc == 2) {
                window.setTimeout(() => {
                    this.notifications.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notifications[index].status = 2;
                        }
                    });
                    this.contarSinLeer(1);
                } , 3);
            } 
            else if (!panic && opc == 3) {
                window.setTimeout(() => {
                    this.notificationsAlerts.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notificationsAlerts[index].status = 2;
                        }
                    });
                    this.contarSinLeer(2);
                } , 3);
            } 
            
            else {
                setTimeout(() => {
                    this.notificacionesPanic.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notificacionesPanic[index].status = 2;
                        }
                    });
                    this.contarSinLeerPanic();
                } , 3);
            }
        });
    }

    marcarTodas(e?, panic?, opc?:number): void {
        e.stopPropagation();

        const notificationStatusUpdate = new NotificationStatusUpdate();
        notificationStatusUpdate.idStatus = 2;

        if (!panic && opc == 2) {
            this.notifications.forEach((notification) => {
                if (notification.status == 1) {
                    notificationStatusUpdate.notification.push(
                        notification.idNotification
                        // createDate: notification.createDate,
                        // idType: notification.idType
                    );
                }
            });
        } 
        else if (!panic && opc == 3) {
            this.notificationsAlerts.forEach((notification) => {
                if (notification.status == 1) {
                    notificationStatusUpdate.notification.push(
                        notification.idNotification
                        // createDate: notification.createDate,
                        // idType: notification.idType
                    );
                }
            });
        }
        else {
            this.notificacionesPanic.forEach((notification) => {
                if (notification.status == 1) {
                    notificationStatusUpdate.notification.push(
                        notification.idNotification
                        // createDate: notification.createDate,
                        // idType: notification.idType
                    );
                }

            });
        }

        this.headerService.updateNotificationStatus(notificationStatusUpdate)
        .subscribe(() => {
            if (!panic && opc == 2) {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notifications.forEach((notification, index) => {
                        // if (
                        //     notificationForUpdate.idType == notification.idType
                        //     && notificationForUpdate.createDate == notification.createDate
                        // ) {
                        //     this.notifications[index].status = notificationStatusUpdate.idStatus;
                        // }
                        if (
                            notificationForUpdate == notification.idNotification
                        ) {
                            this.notifications[index].status = notificationStatusUpdate.idStatus;
                        }
                    });
                });
                this.contarSinLeer(1);
            } 
            if (!panic && opc == 3) {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notificationsAlerts.forEach((notification, index) => {
                        // if (
                        //     notificationForUpdate.idType == notification.idType
                        //     && notificationForUpdate.createDate == notification.createDate
                        // ) {
                        //     this.notifications[index].status = notificationStatusUpdate.idStatus;
                        // }
                        if (
                            notificationForUpdate == notification.idNotification
                        ) {
                            this.notificationsAlerts[index].status = notificationStatusUpdate.idStatus;
                        }
                    });
                });
                this.contarSinLeer(2);
            } 
            else {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notificacionesPanic.forEach((panicNotification, index) => {
                        // if (
                        //     notificationForUpdate.idType == panicNotification.idType
                        //     && notificationForUpdate.createDate == panicNotification.createDate
                        // ){
                        //     this.notificacionesPanic[index].status = notificationStatusUpdate.idStatus;
                        // }
                        if (
                            notificationForUpdate == panicNotification.idNotification
                        ) {
                            this.notificacionesPanic[index].status = notificationStatusUpdate.idStatus;
                        }
                    });
                });
                this.contarSinLeerPanic();
            }

            this.createMessage('success', 'Todas las notificaciones se marcaron como leídas');
        }, (error) => {
            console.error('no fue posible actualizar las notificaciones');
            this.createMessage('error', 'No fue posible marcar todas las notificaciones como leídas');
        });

    }

    elimarUna(notificacion, panic, opc:number): void {
        const notificationStatusUpdate = new NotificationStatusUpdate(notificacion);
        notificationStatusUpdate.idStatus = 4;

        this.headerService.updateNotificationStatus(notificationStatusUpdate)
        .subscribe(() => {
            if (!panic && opc == 2) {
                window.setTimeout(() => {
                    this.notifications.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notifications.splice(index, 1);
                        }
                        let nuevoDato=this.notifications.length.toString();
                        localStorage.setItem("Notificaciones", nuevoDato);
                    });
                    this.contarSinLeer(1);
                } , 3);
            }
            else if (!panic && opc == 3) {
                window.setTimeout(() => {
                    this.notificationsAlerts.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notificationsAlerts.splice(index, 1);
                        }
                        let nuevoDato=this.notificationsAlerts.length.toString();
                        localStorage.setItem("NotificacionesAlerts", nuevoDato);
                    });
                    this.contarSinLeer(2);
                } , 3);
            }
            else {
                setTimeout( () => {
                    this.notificacionesPanic.forEach((item, index) => {
                        if (notificacion.idType == item.idType && notificacion.createDate == item.createDate){
                            this.notificacionesPanic.splice(index, 1);
                        }
                    });
                    this.contarSinLeerPanic();
                } , 3);
            }

            this.createMessage('success', 'La notificación se eliminó');     
        }, (error) => {
            this.createMessage('error', 'No fue posible eliminar la notificación');
            console.error('no se posible eliminar la notificacion');
        }, () => {
        });
    }

    eliminarTodas(e, panic, opc:number): void {
        e.stopPropagation();
        const notificationStatusUpdate = new NotificationStatusUpdate();
        notificationStatusUpdate.idStatus = 4;

        if (!panic && opc == 2) {
            this.notifications.forEach((notification) => {
                notificationStatusUpdate.notification.push(
                    notification.idNotification
                    // createDate: notification.createDate,
                    // idType: notification.idType
                );
            });
        }
        else if (!panic && opc == 3) {
            this.notificationsAlerts.forEach((notification) => {
                notificationStatusUpdate.notification.push(
                    notification.idNotification
                    // createDate: notification.createDate,
                    // idType: notification.idType
                );
            });
        }
        
        else {
            this.notificacionesPanic.forEach((notification) => {
                notificationStatusUpdate.notification.push(
                    notification.idNotification
                    // createDate: notification.createDate,
                    // idType: notification.idType
                );
            });
        }

        this.headerService.updateNotificationStatus(notificationStatusUpdate)
        .subscribe(() => {
            if (!panic && opc == 2) {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notifications.forEach((notification, index) => {
                        // if (
                        //     notificationForUpdate.idType == notification.idType
                        //     && notificationForUpdate.createDate == notification.createDate
                        // ) {
                        //     this.notifications.splice(index, 1);
                        // }
                        if (
                            notificationForUpdate == notification.idNotification
                        ) {
                            this.notifications.splice(index, 1);
                        }
                        
                    });
                });
                this.contarSinLeer(1);
            } 
            else if (!panic && opc == 3) {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notificationsAlerts.forEach((notification, index) => {
                        // if (
                        //     notificationForUpdate.idType == notification.idType
                        //     && notificationForUpdate.createDate == notification.createDate
                        // ) {
                        //     this.notifications.splice(index, 1);
                        // }
                        if (
                            notificationForUpdate == notification.idNotification
                        ) {
                            this.notificationsAlerts.splice(index, 1);
                        }
                        
                    });
                });
                this.contarSinLeer(2);
            } 
            else {
                notificationStatusUpdate.notification.forEach((notificationForUpdate) => {
                    this.notificacionesPanic.forEach((panicNotification, index) => {
                        // if (
                        //     notificationForUpdate.idType == panicNotification.idType
                        //     && notificationForUpdate.createDate == panicNotification.createDate
                        // ) {
                        //     this.notificacionesPanic.splice(index, 1);
                        // }
                        if (
                            notificationForUpdate == panicNotification.idNotification
                        ) {
                            this.notificacionesPanic.splice(index, 1);
                        }

                    });
                });
                this.contarSinLeerPanic();
            }

            this.createMessage('success', 'Se eliminaron exitosamente todas las notificaciones');
            localStorage.setItem("Notificaciones", "0");
        }, (error) => {
            console.error('no fue posible eliminar las notificaciones');
            this.createMessage('error', 'No fue posible eliminar las notificaciones');
        });
    }

    canCategorize(notificationType: NotificationType): boolean {
        return !!this.notificationCategories[notificationType].length;
    }

    toggleNotificationCategorizer(event: MouseEvent, index: number): void {
        event.stopPropagation();
        if (this.notificationCategorizerToggle != index) {
            this.notificationCategorizerToggle = index
        } else {
            delete this.notificationCategorizerToggle;
        }
    }

    setNotificationCategory(category: NotificationCategory, notification: NotificationView, opc:number): void {
        if (Array.isArray(notification.extraInfo)) {
            const indexCategory: number = notification.extraInfo.findIndex((notifExtraInfo) => notifExtraInfo.hasOwnProperty('idCategory'));
            if (indexCategory >= 0) {
                notification.extraInfo[indexCategory] = category;
            } else {
                notification.extraInfo.push(category);
            }
        } else {
            notification.extraInfo = [category];
        }

        const notificationUpdate: NotificationUpdate = new NotificationUpdate(notification);
        notificationUpdate.extraInfo = notification.extraInfo;
        this.headerService.updateNotification(notificationUpdate)
        .subscribe(() => {
            this.createMessage('success', `Notificación actualizada con la categoría ${category.categoryName}`);
        }, (error) => {
            console.error('Error al actualizar notificación', error);
            this.createMessage('error', 'No se pudo actualizar la notificación');
            switch (opc) {
                case 1:
                    const index: number = this.notificacionesPanic
                        .findIndex((notificationFind) => notificationFind.createDate == notification.createDate && notificationFind.idType == notification.idType);
                    if (index >= 0) {
                        this.selectedNotificationCategory[index] = null;
                    }
                    break;
                case 2:
                    const index2: number = this.notifications
                        .findIndex((notificationFind) => notificationFind.createDate == notification.createDate && notificationFind.idType == notification.idType);
                    if (index2 >= 0) {
                        this.selectedNotificationCategory[index2] = null;
                    }
                    break;
                case 3:
                    const index3: number = this.notificationsAlerts
                        .findIndex((notificationFind) => notificationFind.createDate == notification.createDate && notificationFind.idType == notification.idType);
                    if (index3 >= 0) {
                        this.selectedNotificationCategory[index3] = null;
                    }
                    break;
            }  
        });
    }
    cerrarNotificaciones(){
        $('#contPrincipalNoti.open').removeClass('open');
        $('#toggleNotifications').attr('aria-expanded', 'false');
        $('#contentNotificationsPanic').addClass('moverCuadro');
        $('#contPrincipalNotiAlerts.open').removeClass('open');
    }
}

@Component({
    selector: 'notify-modal',
    templateUrl:'./notify.component.html',
    styleUrls: ['header.css'],
    providers: [ BsModalService ]
})
export class NotifyModalComponent implements OnInit {
    isHoveredLeido: boolean = false;
    isHoveredEliminar: boolean = false;
    notifications: any[] = [];
    notification: any;
    notificationCategories: any = [
        { idCategory: 1, categoryName: "Cuadrilla" },
        { idCategory: 2, categoryName: "Seguridad" },
        { idCategory: 3, categoryName: "Medio Ambiente" },
    ];
    comment = '';
    category = null;
    constructor(public bsModalRef: BsModalRef,
        public authService: AuthService,
        private headerService:HeaderService,
        private notificationMessage: NzNotificationService,
    ) { }
    ngOnInit(): void {
        this.headerService.isOpenedNotifyModal = true;
        console.log(this.notifications);
        this.notification = this.notifications[0];
    }

    updateNotification(opc:string): void {
        if (opc == 'leida') {
            if (!this.category || this.category == '') {
                this.createNotification('warning', 'Seleccione una categoria');
                return;
            }
            else {
                this.notification.status = 2;
                let extraInfo = {
                    ...this.notification.extraInfo[0],
                    comment: this.comment,
                    idNotificationCategory: this.category.idCategory,
                    notificationCategoryName: this.category.categoryName,
                    posponer: ''
                };
                this.notification.extraInfo[0] = extraInfo;
            }
        }
        else {
            const currentDate = new Date();
            const futureTime = currentDate.getTime() + (1 * 60 * 1000);
            this.notification.status = 1;
            let extraInfo = {
                ...this.notification.extraInfo[0],
                comment: '',
                idNotificationCategory: '',
                notificationCategoryName: '',
                posponer: moment(futureTime).format('YYYY-MM-DDTHH:mm:ss')
            };
            this.notification.extraInfo[0] = extraInfo;
        }
        this.headerService.updateNotificationSimple(this.notification).subscribe((notification: any) => {
            if (opc == 'leida') {
                const notificationStatusUpdate: NotificationStatusUpdate = new NotificationStatusUpdate(this.notification);
                notificationStatusUpdate.idStatus = 2;
                this.headerService.updateNotificationStatus(notificationStatusUpdate).subscribe((status: any) => {
                    this.headerService.updateLeidaNotifyAndEmitRefresh(this.notification);
                    this.createNotification('success', 'La notificación se marcó como leída.');
                    this.bsModalRef.hide();
                    this.headerService.isOpenedNotifyModal = false;
                }, () => {
                    this.createNotification('error', 'No se pudo actualizar la notificación.');
                });
            }
            else {
                this.bsModalRef.hide();
                this.headerService.isOpenedNotifyModal = false;
                this.createNotification('success', 'La notificación se pospuso.');
            }
        }, (error: any) => {
            this.createNotification('error', 'No se pudo actualizar la notificación.');
        });
    }
    onMouseEnterLeido(): void {
        this.isHoveredLeido = true;
    }

    onMouseLeaveLeido(): void {
        this.isHoveredLeido = false;
    }

    onMouseEnterEliminar(): void {
        this.isHoveredEliminar = true;
    }

    onMouseLeaveEliminar(): void {
        this.isHoveredEliminar = false;
    }
    createNotification(type: string, title?: string, content?: string): void {
        this.notificationMessage.config({
            nzPlacement: 'bottomRight'
        });
        this.notificationMessage.create(
            type,
            title,
            content,
            {
                nzAnimate: true,
            }
        );
    }
}